import React from 'react'
import Container from 'muicss/lib/react/container'

const Footer = () => (
  <footer id="footer">
    <Container className="mui--text-center">
      Made with <span>&hearts;</span> by <a href="http://selects.jp/">SELECTS</a>
    </Container>
  </footer>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer.js